module.exports = __webpack_public_path__ + "img/34.b3833ecf.png";